import React from 'react'
import { useTranslation } from 'react-i18next'
import { CheckinReceiptSheet } from '@/utils/checkin-receipt-sheets'

type Props = CheckinReceiptSheet['heading']

const titleKeys: Record<NonNullable<Props['title']>, string> = {
  accommodation: 'SelfCheckIn.Accommodation',
}

export const SheetHeading: React.FC<Props> = ({ logoImage, title }) => {
  const { t } = useTranslation()
  return (
    <>
      {logoImage && (
        <div className="logo-block">
          <img src={logoImage} alt="receipt logo" />
        </div>
      )}
      {/* 下の線の幅と余白を宿泊情報と同じにするため、線も .accommodation-block の中に置く。ロゴだけの紙でも先頭の下に線を引く */}
      <div className="accommodation-block">
        {title && <h2>{t(titleKeys[title])}</h2>}
        <hr className="-normal" />
      </div>
    </>
  )
}
